// extracted by mini-css-extract-plugin
module.exports = {"FormRow":"VendorCompanyModal_FormRow__japr9","FormCol":"VendorCompanyModal_FormCol__Sm_cy"};